// extracted by mini-css-extract-plugin
module.exports = {"arrow":"TimeLine_arrow__4ihk_","dot":"TimeLine_dot__sTZ1K"};